export const inspection = {
  path: "/laporan-pemeriksaan",
  name: "Inspection Report",
  hidden: false,
  component: () => import("@/components/inspection_report/index"),
  meta: {
    title: "Laporan Pemeriksaan",
    icon: "fa-user",
    roles: ["dokter", "pasien"]
  }
};
export default inspection;



// WEBPACK FOOTER //
// ./src/router/modules/inspectionReport.js